/* unplugin-vue-components disabled */import { render } from "./xsplitPane.vue?vue&type=template&id=75b50b4b"
import script from "./xsplitPane.vue?vue&type=script&lang=js"
export * from "./xsplitPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__